import { AddViewerMultiLineTextEdit } from "../utils/AddViewerMultiLineTextEdit";
import { AddWrapTextCentered } from "../utils/AddWrapTextCentered";
import { appstr } from "../utils/appstr";
import { BreakContent } from "../utils/BreakContent";
import { BuildFontString } from "../utils/BuildFontString";
import {
  enumButtonIconPosition,
  enumElementBorderStyle,
  enumKeyboardTargetEnterAction,
  enumPanelBorderStyle,
  kDownArrow,
  kEscKey,
  kFramelessDropDownWidth,
  kFramelessHeaderHeight,
  kIndent,
  kRed,
  kScrollBarButtonSize,
  kSearchIcon,
  kTabKey,
  kWebFrameMargin
} from "../constants";
import { QDropDownButton } from "./QDropDownButton";
import { QDropDownDivider } from "./QDropDownDivider";
import { QDropDownElement } from "./QDropDownElement";
import { QDropDownViewPort } from "./QDropDownViewPort";
import { QPanel } from "./QPanel";
import { Globals } from "./Globals.js";
import { QOptionArray } from "./QOptionArray.js";
import { MeasureTextHeight } from "../utils/MeasureTextHeight.js";
import { AddWrapText } from "../utils/AddWrapText.js";

export class QDropDown extends QPanel {
  constructor() {
    super();
    this.fBaseCode = null;
    this.fParentPanel = null;
    this.fOptionsList = null;
    this.fWSMgr = null;
    this.fIndex = null;
    this.fMaxRows = 15;
    this.fCurPage = 0;
    this.fNumPages = 0;
    this.fSourceVBuffer = 3;
    this.fDDWidth = kFramelessDropDownWidth * 1.3;
    this.fSearchKey = "";
    this.fLoadMsg = null;
    this.fNoResultsMsg = null;
    this.fPortPanel = null;
    this.fLimit = true;
    this.fLegacyMode = false;
    this.fScaleWidthToHeader = false;
    this.fMatchParentZLayer = true;
    this.fUseTheme = false;
    this.fIconPosition = enumButtonIconPosition.left;
    this.fCustomViewPortFormatting = true;
    this.fElementHeight = 30;
    this.fFontSize = 12;
    this.fHighlightSelections = false;
    this.fShowSearch = true;
    this.fSearchTE = null;
    this.fFontString = "12px Arial";
    this.fSizeToScreen = false;
    this.fDividerAboveOptList = [];
  }

  InitDropDown(WSMgr, parentPanel, header, optionsList, index, matchParentZLayer, srcElement) {
    this.fWSMgr = WSMgr;
    this.fUIColors = WSMgr.GetUIColors();
    this.fParentPanel = parentPanel;
    this.fIndex = index;
    this.fHeaderStr = header;
    this.fSrcElement = srcElement;
    this.fMatchParentZLayer = matchParentZLayer;
    this.fAllowPaging = true;

    this.SetModalOn(true);
    this.SetOutsideClickDismissOn(true);
    this.SetShadowOn(true);
    if (
      this.fDDWidth === kFramelessDropDownWidth * 1.3 &&
      this.fSrcElement &&
      this.fSrcElement instanceof QDropDownButton
    ) {
      var defaultWidth = this.fSrcElement.GetWidth();
      if (defaultWidth < 100) defaultWidth = this.fDDWidth;
      if (this.fSrcElement.fFontSize) this.fFontSize = this.fSrcElement.fFontSize;
      this.fDDWidth = defaultWidth;
    }
    if (Globals._mobileDevice) {
      this.InitMobileParams();
    }

    this.FormatPanel();

    this.InitZLayers(matchParentZLayer);
    this.InitializeSmartDisplayPort();

    this.SizePanel(this.fDDWidth, this.fElementHeight + kFramelessHeaderHeight * 2);
    WSMgr.PushPanel(this);

    this.GetPanelOnScreen();
    if (this.fSrcElement) this.SmartPositionPanel(this.fSrcElement);

    this.UpdateFramelessDropDown(header, optionsList);
    this.fWSMgr.SetKeyboardTarget(this.fSearchTE, this, enumKeyboardTargetEnterAction.insertAtEnd);
  }

  FormatPortPanel(portPanel) {
    portPanel.SetBorderStyle(enumPanelBorderStyle.roundBorder);
    portPanel.SetBorderThickness(0);
    portPanel.SetBorderRadius(this.fBorderRadius);
    portPanel.SetBorderColor(this.GetFillColor());
    //portPanel.SetFillColor(kRed);
  }

  FormatPanel() {
    var panelColors = this.GetPanelColors();
    var fillColor = "#FFFFFF";
    var borderColor = panelColors["border"];
    this.SetFillColor(fillColor);
    this.SetBorderColor(borderColor);
    this.SetBorderStyle(enumPanelBorderStyle.roundBorder);
    this.SetBorderThickness(1);
    this.SetBorderRadius(4);
  }

  UpdateFramelessDropDown(header, optionsList) {
    if (header != null) this.fHeaderStr = header;
    if (optionsList != null) this.fOptionsList = optionsList;
    this.UpdatePanel();
    // persist highlight
    this.PersistHighlightCache();
  }

  BuildBasicOptions(
    baseCmd,
    optionsList,
    curValue,
    doLookup,
    subCodeList = null,
    faIconList = null,
    hoverCodeList = null
  ) {
    this.fBaseCmd = baseCmd;
    var ddArray = new QOptionArray();
    if (optionsList == null) return ddArray;
    var dividerAboveList = this.fDividerAboveOptList || [];
    for (var i = 0; i < optionsList.length; i++) {
      var aOption = optionsList[i];
      var oName = aOption;
      if (doLookup && aOption.length > 0) oName = appstr(aOption);
      var subCode = this.ProcessOptionCode(aOption);
      var faIcon = null;
      var hoverCode = null;

      // alternatively u can pass list of sub codes, icons, and hover codes (not required)
      if (faIconList != null) {
        var iconStr = faIconList[i];
        if (iconStr && iconStr.length > 0) faIcon = iconStr;
      }
      if (hoverCodeList != null) {
        hoverCode = hoverCodeList[i];
      }
      if (subCodeList != null) {
        subCode = subCodeList[i];
      }

      var curOption = ddArray.addOption(
        baseCmd + "-" + subCode,
        false,
        oName,
        null,
        false,
        faIcon,
        null,
        null,
        hoverCode
      );
      curOption.fAdditionalCmdParameters = { groupidx: subCode };
      curOption.fButtonIndex = i;
      curOption.fIsActive = subCode === curValue;
      if (dividerAboveList && dividerAboveList.includes(aOption)) curOption.fHasDivider = true;
    }
    return ddArray;
  }

  CanvasRightClickCommonInit(
    baseCode,
    wsMgr,
    srcElement,
    optionLabelList,
    cmdList,
    faIconList,
    appstrLabels,
    x,
    y,
    hoverCodeList
  ) {
    if (!wsMgr.fCanvasPanel) return;
    this.fCmdList = cmdList;
    this.fFontSize = 14;
    this.fFontString = "14px Verdana";
    var optionsArray = this.BuildBasicOptions(
      baseCode,
      optionLabelList,
      null,
      appstrLabels === true,
      cmdList,
      faIconList,
      hoverCodeList
    );
    this.InitDropDown(wsMgr, wsMgr.fCanvasPanel, null, optionsArray, 0, false, srcElement);
    this.PositionPanel(x, y);
    this.GetPanelOnScreen();
  }

  ProcessOptionCode(aOption) {
    // override for special handling
    return aOption;
  }

  PositionPanel(x, y) {
    this.DoPositionPanel(x, y);
    this.fHorzOffset = x;
    this.fVertOffset = y;
    this.SmartPositionPortPanel(x, y);
  }

  PostStandardResize() {
    this.SmartPositionPanel(this.fSrcElement);
    this.UpdatePanel();
  }

  DoCustomPositioning() {}

  GetPanelColors() {
    return {
      fill: this.fUIColors.GetPrimaryPanelFillColor(),
      border: this.fUIColors.GetPanelBorderColor(),
      text: this.fUIColors.GetBodyTextColor()
    };
  }

  InitMobileParams() {
    this.fElementHeight = 35;
    this.fFontSize = 13;
    this.fFontString = "13px Arial";
    var availableHeight = this.fWSMgr.GetAvailableMobileHeight();
    var minRows = Math.floor(availableHeight / this.fElementHeight) - 2;
    this.fDDWidth = this.fWSMgr.GetCanvasWidth();
    this.fMaxRows = minRows < 10 ? minRows : 10;
    this.SetPanelPanHideScrollBarMode();
  }

  InitZLayers(matchParent) {
    var matchZLayer = true;
    var parentPanel = this.fParentPanel;
    if (matchParent) matchZLayer = matchParent;
    if (parentPanel && parentPanel.fZLayer && matchZLayer) {
      var zLayer = parentPanel.fZLayer;
      if (zLayer < 2) zLayer = 2;
      this.SetZLayer(zLayer);
      if (this.fPortPanel) this.fPortPanel.SetZLayer(zLayer);
    }
  }

  GetPortPanel() {
    return new QDropDownViewPort();
  }

  SetDDWidth(ddWidth) {
    this.fDDWidth = ddWidth;
  }

  SetMaxRows(maxRows) {
    this.fMaxRows = maxRows;
  }

  GetMaxRows() {
    return this.fMaxRows;
  }

  GetListID() {
    return this.fListRef.GetListID();
  }

  SetOpenAfterSelection(stayAlive) {
    this.fStayAlive = stayAlive;
  }

  PersistHighlightCache() {
    var highlightCache = this.fPortPanel.GetHighlightCache();
    if (highlightCache != null && highlightCache.length > 0) {
      var highlightElement = highlightCache[0];
      var PortElements = this.fPortPanel.fElements;
      for (var i = 0; i < PortElements.length; i++) {
        if (PortElements[i] instanceof QDropDownElement) {
          if (PortElements[i].fName == highlightElement.fName) {
            this.DoHighlightElement(PortElements[i], true);
            this.fPortPanel.fHighlightCache = [PortElements[i]];
          }
        }
      }
    }
  }

  ShowFinder(options) {
    if (!this.fShowSearch) return false;
    var maxRows = this.GetMaxRows();
    var optionsList = this.GetOptionsList(options);
    var numItems = optionsList.length;
    return numItems > maxRows;
  }

  InitializeExtras() {
    var header = this.fHeaderStr;
    var showFinder = this.ShowFinder();
    var portWidth = this.fDDWidth - kScrollBarButtonSize;
    var teFillColor = this.fUIColors.GetTextEditFillColor();
    var teBorderColor = this.fUIColors.GetTextEditBorderColor();
    var textEditBorder = this.fBorderRadius;
    var portStartY = header ? kFramelessHeaderHeight + 2 : 0;
    var headerYOffset = portStartY + textEditBorder;
    this.fBaseCode = header;

    if (showFinder) {
      this.fSearchTE = AddViewerMultiLineTextEdit(
        this,
        textEditBorder,
        headerYOffset,
        portWidth + kScrollBarButtonSize - textEditBorder * 2,
        this.fElementHeight + 3,
        appstr("Search"),
        70,
        0,
        true,
        1,
        true
      );
      this.fSearchTE.AddClearButton();
      this.fSearchTE.fClearButton.SetCmdCode("ClearSearchBarButton");
      this.fSearchTE.SetFontIcon(kSearchIcon);
      this.fSearchTE.SetFillColor(teFillColor);
      this.fSearchTE.SetBorderColor(teBorderColor);
      this.fSearchTE.fFontSize = this.fFontSize;
      this.fSearchTE.fFontName = "Arial";

      headerYOffset += this.fSearchTE.GetHeight() + textEditBorder * 2;

      var searchDivider = new QDropDownDivider();
      searchDivider.PositionElement(0, headerYOffset);
      searchDivider.SizeElement(portWidth + kScrollBarButtonSize, 0.5);
      this.PushElement(searchDivider);
    }

    this.fPortStartY = headerYOffset;
    this.fBottomBuffer = this.fBorderRadius;
    var calcHeight = this.ReCalculateDDHeight();
    var bottomBuffer = this.fBottomBuffer + 2;
    var panelHeight = calcHeight + bottomBuffer;
    this.SizePanel(this.fDDWidth, panelHeight);
    if (this.fSrcElement) this.SmartPositionPanel(this.fSrcElement);
    this.DoCustomPositioning();
  }

  AddContent() {
    var yPos = this.AddDropDownElements();

    return { width: 0, height: yPos };
  }

  GetElemWidth() {
    var xPos = 2;
    var pWidth = this.GetWidth() - xPos * 2;
    if (this.ShowFinder()) pWidth -= kScrollBarButtonSize;
    return pWidth;
  }

  GetFilteredOptionList() {
    var optionsList = this.GetOptionsList();
    if (this.fSearchTE && this.fSearchKey != "")
      optionsList = optionsList.filter(this.FilterValues(this.fSearchKey));
    return optionsList;
  }

  AddDropDownElements() {
    this.fBaseCode = this.fHeaderStr;

    var yPos = this.fBorderRadius;
    var panelColors = this.GetPanelColors();
    var textColor = panelColors["text"];
    var optionsList = this.GetFilteredOptionList();

    var numItems = optionsList.length;

    if (this.fSearchTE) {
      this.fSearchTE.SetEditContent(this.fSearchKey);
    }

    if (this.fLimit && numItems > 1000) {
      AddWrapTextCentered(
        this.fPortPanel,
        5,
        22,
        this.fWidth - 15,
        "Too many matches - (" + numItems.toString() + ") Narrow search",
        false,
        textColor,
        "Arial",
        this.fFontSize
      );
    } else if (numItems === 0) {
      var msg = this.GetNoResultsMessage();
      if (this.fParentPanel && this.fParentPanel.fRFCActive) msg = this.GetLoadMessage();
      this.AddWrapMessage(msg, textColor);
    } else {
      yPos = this.AddOptions(optionsList);
    }

    return yPos;
  }

  GetDropDownElement() {
    return new QDropDownElement();
  }

  AddOptions(optionsList) {
    optionsList = this.GetPaginatedViewPortContent(optionsList);

    var elemWidth = this.GetElemWidth();
    var numItems = optionsList.length;
    var iconOffset = 0;

    var elementHBuffer = 1;
    var elementVBuffer = 2;
    var yPos = 0;
    var xPos = 0;

    var stdElemHeight = this.fElementHeight + 5;
    var elemVSpace = stdElemHeight + elementVBuffer;

    for (var y = 0; y < numItems; y++) {
      var o = optionsList[y];

      if (o.fHasDivider) {
        var divider = new QDropDownDivider();
        divider.PositionElement(xPos, yPos);
        if (y < numItems - 1) yPos += elementVBuffer;
        divider.SizeElement(elemWidth, stdElemHeight);
        this.fPortPanel.PushElement(divider);
      }

      var dropButton = this.GetDropDownElement();
      dropButton.fParent = this.fPortPanel;
      dropButton.SetUIColors(this.fUIColors);
      dropButton.PositionElement(elementHBuffer, yPos);
      dropButton.SizeElement(elemWidth, stdElemHeight);
      dropButton.SetBorderRadius(2);
      dropButton.SetBorderStyle(enumElementBorderStyle.roundBorder);
      dropButton.SetBorderThickness(0);
      dropButton.SetBorderColor(this.fUIColors.GetButtonBorderColor());
      dropButton.SetFillColor(this.fUIColors.GetButtonFillColor());

      dropButton.fFontString = BuildFontString("Arial", this.fFontSize, false, false);

      if (y < numItems - 1) yPos += elemVSpace;

      var buttonCmdCode2 = this.fBaseCode + "-";
      buttonCmdCode2 = buttonCmdCode2.concat(y);

      if (o.fIconPosition !== null && o.fIconPosition !== undefined)
        dropButton.fIconPosition = o.fIconPosition;

      var theName = o.fName;
      dropButton.fIsGoCmd = o.fIsGoCmd;
      dropButton.fToggle = o.fIsToggle;
      dropButton.SetName(theName);
      if (o.fLabel) {
        dropButton.SetNameExplicit(o.fLabel);
      }

      if (o.fOverrideTextColor != null) dropButton.fOverrideTextColor = o.fOverrideTextColor;

      if (o.fIsDividerText || o.fBoldLabel) {
        dropButton.fIsDividerText = o.fIsDividerText;
        dropButton.fFontString = BuildFontString("Arial", this.fFontSize + 1, true, false);
      }

      dropButton.fIsPaywall = o.fIsPaywall;
      dropButton.fIsActive = o.fIsActive;

      if (o.fElement) dropButton.fElement = o.fElement;

      if (o.fIsToggle) {
        dropButton.SetLabelPosition("left");
        dropButton.fCurValue = o.fCurValue;
        dropButton.SetToggleName();
      }
      if (o.fHoverTip) dropButton.SetHoverCode(o.fHoverTip);

      if (o.fDoubleSize) {
        var buttonH = dropButton.GetHeight();
        dropButton.SetHeight(buttonH * 2);
        if (y < numItems - 1) yPos += buttonH;
        dropButton.fDoubleSize = true;
        dropButton.fContentRows = BreakContent(
          dropButton.fName,
          2,
          dropButton.fToggle ? this.fWidth * 0.75 : this.fWidth,
          0,
          5,
          this.fFontString,
          null
        );
      }

      dropButton.SetCmdCode(o.fCmdCode);
      if (o.fCmdCode == null || o.fDisabled) dropButton.SetEnabled(false);
      if (o.fHoverCode) dropButton.SetHoverCode(o.fHoverCode);

      if (o.fIcon) {
        dropButton.fIcon = o.fIcon;
        iconOffset = 16;
      }

      if (o.fIconColor) dropButton.fIconColor = o.fIconColor;

      if (o.fSubCmds != null)
        // TODO: this parallel system needs to be brought over to AdditionalCmdParams. fSubCmds was a first pass at this type of cmd handling.
        dropButton.fSubCmds = o.fSubCmds;
      for (var aKey in o.fAdditionalCmdParameters)
        dropButton.AddCmdParameter(aKey, o.fAdditionalCmdParameters[aKey]);

      if (o.fFontIconStyle) {
        dropButton.fFontIconStyle = o.fFontIconStyle;
        iconOffset = parseInt(o.fFontIconStyle.split("px")[0].slice(-2)) + kIndent;
      }

      if (o.fButtonIndex != null) {
        dropButton.fButtonIndex = o.fButtonIndex;
        var enabled = this.ButtonEnabled(dropButton.fButtonIndex);
        dropButton.SetEnabled(enabled);
      }

      if (this.fUseTheme) dropButton.fUseTheme = true;

      if (this.fHighlightSelections) dropButton.fHighlightSelections = this.fHighlightSelections;

      this.fPortPanel.PushElement(dropButton);
    }

    this.fPortPanel.fIconOffset =
      this.fIconPosition === enumButtonIconPosition.left ? iconOffset : 0;

    yPos += stdElemHeight;

    return yPos;
  }

  ButtonEnabled() {
    return true;
  }

  GetOptionsList(optionsList) {
    if (optionsList == null) optionsList = this.fOptionsList.fArray;
    else optionsList = optionsList.fArray;

    if (optionsList == null) optionsList = [];

    return optionsList;
  }

  ReCalculateDDHeight() {
    var optionList = this.GetFilteredOptionList();
    var backgroundPanel = this.fWSMgr.fBackgroundPanel;
    var elemBuffer = 2;
    var yStart = this.fPortStartY;
    var numItems = optionList.length;
    var maxRows = this.fMaxRows;

    if (numItems === 0) {
      var noResults = this.GetNoResultsMessage();
      var contentRows = BreakContent(noResults, 3, this.fPortWidth, 0, 5, this.fFontString);
      maxRows =
        (contentRows.length *
          MeasureTextHeight(this.fFontString, this.fFontString.split("px")[0])) /
        this.fElementHeight;
    }

    var elemSpacing = this.fElementHeight + elemBuffer + 5;
    var panelHeight = maxRows * elemSpacing + yStart;

    if (!Globals._mobileDevice) {
      var clientHeight = backgroundPanel.GetHeight();
      var availableHeight = clientHeight - kWebFrameMargin * 2;

      if (this.fSizeToScreen) availableHeight -= this.GetPositionY();

      var actualHeight = panelHeight;
      if (actualHeight > availableHeight) {
        maxRows = Math.floor(availableHeight / elemSpacing);
        panelHeight = maxRows * elemSpacing;
      }
    }

    if (optionList && numItems > 0) {
      var calcHeight = yStart;
      for (var optionIdx in optionList) {
        var anOption = optionList[optionIdx];
        var height = this.fElementHeight + 5;
        if (anOption.fDoubleSize) height *= 2;
        calcHeight += height + elemBuffer;
      }
      if (calcHeight < panelHeight) panelHeight = calcHeight + elemBuffer;
    }

    return panelHeight;
  }

  PanelHandleKeyboard(keyInfo, targetElement, wsMgr) {
    var keyCode = keyInfo.keyCode;
    var handled = false;
    switch (keyCode) {
      case kDownArrow:
      case kTabKey:
        var targetPanel = this.fPortPanel;
        if (targetPanel.fElements && targetPanel.fElements.length > 0) {
          var index =
            Globals._wsMgr.ShiftDown() && keyCode === kTabKey
              ? targetPanel.fElements.length - 1
              : 0;
          targetElement = targetPanel.fElements[index];
          if (index > 0) {
            targetPanel.SetPanY(targetElement.fVertOffset - targetPanel.fPortHeight + 27);
          }
          this.fWSMgr.SetKeyboardTarget(targetElement, targetPanel, null);
        }
        handled = true;
        break;
      case kEscKey:
        var buttonArray = this.fParentPanel.fButtonArray;
        if (buttonArray && buttonArray.length > 0)
          this.fParentPanel.fButtonArray[this.fIndex].fIsActive = false;
        this.NukePanel();
        handled = true;
        break;
    }
    return handled;
  }

  AddWrapMessage(label, textColor) {
    var availableWidth = this.GetPortWidth();
    var wrapText = AddWrapText(
      this.fPortPanel,
      0,
      0,
      availableWidth,
      label,
      false,
      textColor,
      "Arial",
      this.fFontSize
    );

    wrapText.SetAlignment("center");
    return wrapText;
  }

  FilterValues(string) {
    var ObjectKey = this.fObjectKey;
    return function (item) {
      var Label = item.fName;
      if (typeof Label === "string") {
      } else {
        Label = Label[ObjectKey];
      }
      return Label.toLowerCase().lastIndexOf(string.toLowerCase()) != -1;
    };
  }

  // shift (optionally shift drop down by source height) this will automatically happen if no header or search TE present)
  // source (optionally specify source to auto position drop down and pass null for x and y).
  HandleListCommand(aCmd) {
    var listMgr = this.fListMgr;
    var listID = this.fListID;
    var targetList = listMgr.GetListByID(listID);
    if (targetList == null) return false;
    return targetList.ExecuteCommand(aCmd);
  }

  ExecuteCommand(aCmd) {
    //Override this behavior when in main dropdown panels
    var cmdCode = aCmd.GetCmdCode();
    var wsMgr = aCmd.GetWSMgr();
    var srcElement = aCmd.GetSourceElement();
    var panelHandled = false;

    var cmdProcessor = cmdCode.split("-");
    if (cmdProcessor.length > 1 && cmdProcessor != cmdCode) {
      cmdCode = cmdProcessor.shift();
      var subCode = cmdProcessor.join("-");
      aCmd["newvalue"] = subCode;
      panelHandled = true;
    }

    if (this.fTarget) aCmd["targetElem"] = this.fTarget;
    if (this.fSrcElement) aCmd["sourceElem"] = this.fSrcElement;

    switch (cmdCode) {
      case "basicToggle":
        var newOption = subCode;
        var index = this.fActiveSourceList.indexOf(newOption);
        if (newOption === "Show All") this.fActiveSourceList = [];
        else if (index > -1) this.fActiveSourceList.splice(index, 1);
        else this.fActiveSourceList.push(newOption);
        if (this.fRebuildToggleList) this.fToggleSetList = this.RebuildToggleList();
        this.UpdateFramelessDropDown(null, this.BuildBasicOptions(this.fToggleSetList));
        this.fParentPanel.UpdatePanel();
        break;
      case "toggleOption":
        this.HandleListCommand(aCmd);
        this.DoAfterToggle(aCmd);
        break;
      case "TEKeyPress":
        var searchKey = this.fSearchTE.GetRealContent();
        this.fSearchKey = searchKey;
        this.UpdateFramelessDropDown(null, null);
        break;
      case "ClearSearchBarButton":
        var textEdit = srcElement["textedit"];
        if (!textEdit) break;
        textEdit.SetEditContent("");
        this.fSearchKey = "";
        this.UpdateFramelessDropDown(null, null);
        break;
      case "TESelectAll": // return false if we want wsmgr to handle it
        return false;
      case "framelessNextPage":
        this.fCurPage++;
        this.UpdateFramelessDropDown(null, null);
        break;
      case "framelessPrevPage":
        this.fCurPage--;
        this.UpdateFramelessDropDown(null, null);
        break;
      case "CNCL":
        this.NukePanel();
        break;
      case "DoCellAction":
      case "CanvasRightClick":
        this.NukePanel();
        break;
      default:
        if (!this.fStayAlive) {
          this.NukePanel();
        }
        panelHandled = this.fParentPanel.ExecuteCommand(aCmd);
    }

    return panelHandled;
  }

  // ==================================================
  // methods for setting standard status messages for different panel states (e.g. loading, no search result, etc.) and could be overridden
  GetLoadMessage() {
    if (!this.fLoadMsg) return appstr("Loading") + "...";
    return this.fLoadMsg;
  }

  SetLoadMessage(loadStr) {
    this.fLoadMsg = loadStr;
  }

  GetNoResultsMessage() {
    if (!this.fNoResultsMsg) return appstr("nosearchresults");
    return this.fNoResultsMsg;
  }

  SetNoResultsMessage(noResultsStr) {
    this.fNoResultsMsg = noResultsStr;
  }

  DoAfterToggle() {
    //override this
  }

  InitListMgr() {
    //override this
  }
}
